export const POPULAR_CITIES = [
  "Mumbai",
  "Delhi",
  "Bangalore",
  "Hyderabad",
  "Lucknow",
  "Chennai",
  "Pune",
  "Kolkata",
  "Patna",
  "Jaipur"
];